import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/ets")({
	component: EtsLayout,
})

function EtsLayout() {
	return <Outlet />
}
